<div class="login">

    <div class="middle-box text-center loginscreen  animated fadeInDown">
        <div>
            <img src="../../../assets/imgs/logo.png" alt="logo"/>
            <div class="login_box">
                <h3>Employee Appraisal</h3>
                <form class="m-t" role="form" action="#" (submit)="login()">
                    <div class="row">
                        <div class="col-xs-12 mh-64">
                        <app-epa-input label="Email" [required]="true" [control]="loginForm.get('email')">
                        </app-epa-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12 mh-64 _tooltip">
                            <app-epa-input appCheckCapslock (capsLock)="capsLock($event)"
                                           label="Password" 
                                           [required]="true"
                                           [control]="loginForm.get('password')"
                                           type="password"
                                           [showEye]="true"></app-epa-input>
                            <span *ngIf="isCapsLockOn" class="_tooltiptext">Caps-lock is on</span>
                        </div>
                    </div>


                    <div class="text-left m-b-sm m-t-sm">
                        <label class="k-form-field">
                        <input type="checkbox" id="auth-2fa" class="k-checkbox">
                        <label class="k-checkbox-label" for="auth-2fa">Remember me</label>
                        </label>
                    </div>
                    <button type="submit" class="btn btn-primary block full-width m-b" [disabled]="!loginForm.valid">Login</button>
                    <a [routerLink]="['/forgotpassword']"><small>Forgot your password?</small></a>
                    <p class="errorMessage" *ngIf="err_message">{{err_message}}</p>
                </form>
            </div>
        </div>
    </div>
</div>
